import React from "react";
import "./FrontendLeedflow.css";
import AppTheme from "./theme/AppTheme";
import AppRouter from "./AppRouter";

const FrontendLeedflow: React.FC = () => {
  return (
    <AppTheme>
      <AppRouter />
    </AppTheme>
  );
};

export default FrontendLeedflow;
